export const manageChat = ({ close }: { close?: boolean }) => {
  //@ts-ignore:
  const chatWidget: { load: Function; close: Function; remove: Function } = window.HubSpotConversations?.widget;

  // console.warn('manageChat', { close, chatWidget });

  if (chatWidget) {
    if (close) {
      // console.log('closing chat');
      chatWidget.close();
      chatWidget.remove();
    } else {
      // console.log('opening chat');
      chatWidget.load();
      chatWidget.close();
    }
    return chatWidget;
    // } else {
    //   console.log('no chat found');
  }
};
